import { Draggable } from "@msuite/ui/dnd";
import { Icon } from "@msuite/ui/icons";
import { createColumnHelper, createMeta } from "@msuite/ui/table";
import { getAtomicNumberString } from "@msuite/utils/organizations";
import type { Tables } from "@msuite/utils/types";

const columnHelper = createColumnHelper<Tables<"organizationServicesWithFullNumber">>();

export const columns = [
	columnHelper.display({
		id: "drag-handle",
		header: "",
		cell: (cell) => (
			<div className="absolute inset-0">
				<Draggable
					type="service"
					item={cell.row.original}
					className="w-full h-full flex-center"
					Preview={() => (
						<div className="card">
							<p className="label">{getAtomicNumberString(cell.row.original.fullNumber)}</p>
							<p>{cell.row.original.shortText}</p>
						</div>
					)}
				>
					<Icon name="GripVertical" />
				</Draggable>
			</div>
		),
		size: 40,
		meta: createMeta({
			hideOptions: true,
			withoutPadding: true,
		}),
	}),
];
